module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#photostory",
      toString: function () {
        return this.url;
      }
    }